__turbopack_context__.v({
  "badge": "_0dHXEW_badge",
  "feed": "_0dHXEW_feed",
  "feedImage": "_0dHXEW_feedImage",
});
